import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import Select from 'react-select';

const DetailsDescResultsSelect = ({clang, label, input, options, disabled, placeholder, meta: { touched, error }, dispatch, handleSubmit}) => {
    return (
        <div className="results__details__field--select">
            <label className="results__details__field-label" htmlFor={input.name}>
                {label}
                {label && <span>:</span>}
            </label>
            <Select
                {...input}
                // value={input.value}
                disabled={disabled}
                inputValue={input.value}
                className="results__details__input--select"
                // clearable={false}
                placeholder={placeholder}
                // deleteRemoves={true}
                // backspaceRemoves={false}
                // searchable={true}
                options={options}/>
            {touched && (error && <span className="results__details__field__error">{lang[clang].validation[error]}</span>)}
        </div>
    );
};

DetailsDescResultsSelect.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(DetailsDescResultsSelect);



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsDescResultsSelect.js